export type IconSizeType = 'small' | 'middle' | 'large' | 'custom-shild' | 'custom-status';
export const iconSizeArray: Array<IconSizeType> = [
  'small',
  'middle',
  'large',
  'custom-shild',
  'custom-status',
];
